import request from '@/utils/request'

export function getDealers(params) {
    return request({
        url: '/dealers',
        method: 'get',
        params
    })
}